/**
 * submissionService — Firestore reads for widget_submissions + Cloud Function invocations.
 */

import { db } from '../firebase/config';
import {
  collection,
  doc,
  getDocs,
  getDoc,
  query,
  where,
  orderBy,
  limit,
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// ──────────────────────────────────────────
// Read operations
// ──────────────────────────────────────────

export async function getSubmissions(status = null, maxItems = 50) {
  let q;
  if (status) {
    q = query(
      collection(db, 'widget_submissions'),
      where('status', '==', status),
      orderBy('submittedAt', 'desc'),
      limit(maxItems)
    );
  } else {
    q = query(
      collection(db, 'widget_submissions'),
      orderBy('submittedAt', 'desc'),
      limit(maxItems)
    );
  }
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function getSubmissionById(id) {
  const ref = doc(db, 'widget_submissions', id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export async function getSubmissionStats() {
  const [pending, approved, rejected] = await Promise.all([
    getDocs(query(collection(db, 'widget_submissions'), where('status', '==', 'pending'))),
    getDocs(query(collection(db, 'widget_submissions'), where('status', '==', 'approved'))),
    getDocs(query(collection(db, 'widget_submissions'), where('status', '==', 'rejected'))),
  ]);
  return {
    pending: pending.size,
    approved: approved.size,
    rejected: rejected.size,
    total: pending.size + approved.size + rejected.size,
  };
}

// ──────────────────────────────────────────
// Cloud Function invocations
// ──────────────────────────────────────────

export async function callSubmitWidget(data) {
  const fn = httpsCallable(functions, 'submitWidget');
  const result = await fn(data);
  return result.data;
}

export async function callApproveWidget(submissionId, action, reviewNotes = '', overrides = {}, existingWidgetId = null) {
  const fn = httpsCallable(functions, 'approveWidget');
  const result = await fn({ submissionId, action, reviewNotes, overrides, existingWidgetId });
  return result.data;
}

export async function callSubmitBlogDraft(data) {
  const fn = httpsCallable(functions, 'submitBlogDraft');
  const result = await fn(data);
  return result.data;
}
